export enum PolicyStatus {
  ACTIVE = 'Active',
  IN_RENEWAL = 'InRenewal',
  OVERDUE = 'Overdue',
  EXPIRED = 'Expired',
  CANCELLED = 'Cancelled',
}
